/* Wanelo Vibe — PULSE: living hero showcase (Trending now / Flash drop / AI pick).
 *
 * Server renders a static fallback (SEO / no-JS) + a JSON pool per section.
 * This module re-picks what each USER sees, so the sections keep refreshing:
 *
 *   1. SLOT ROTATION  — seed = hash(uid : 6h-slot : section). Every device gets
 *      its own anonymous uid, so every user sees a different showcase, and it
 *      re-rolls itself 4x/day. Stable within a slot (no flicker on reloads).
 *   2. NOVELTY MEMORY — items already shown to this user decay (48h half-life):
 *      each visit quietly surfaces things they have NOT seen yet.
 *   3. LIGHT AFFINITY — clicks (w3) + long hovers (w0.5) on showcase items build
 *      a tiny tag profile; candidates are scored toward the user's taste.
 *      (The personalized-feed engine + its storage contract are untouched.)
 *   4. SCORE = .42*affinity + .28*novelty + .18*merch + .12*seeded jitter
 *      merch: Trending = curated pool order; Flash drop = discount depth.
 *
 *   Flash-drop countdown = time left in the CURRENT slot; when it hits zero the
 *   set genuinely re-rolls in place (honest urgency, no reload needed).
 *
 * Debug: window.VIBE_PULSE.reroll() forces a next-slot preview.
 */
(function () {
  'use strict';
  var SLOT_MS = 6 * 3600 * 1000;            // rotation window
  var LS = { uid: 'vibe_uid', seen: 'vibe_pulse_seen', aff: 'vibe_pulse_aff' };

  function lsGet(k, fb) { try { var v = localStorage.getItem(k); return v == null ? fb : JSON.parse(v); } catch (e) { return fb; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  // ---- identity & seeded PRNG -------------------------------------------------
  function uid() {
    var u = null;
    try { u = localStorage.getItem(LS.uid); } catch (e) {}
    if (!u) { u = Math.random().toString(36).slice(2) + Date.now().toString(36); try { localStorage.setItem(LS.uid, u); } catch (e) {} }
    return u;
  }
  function hash(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function rng(seed) { var a = seed >>> 0; return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function slotNo(off) { return Math.floor(Date.now() / SLOT_MS) + (off || 0); }

  // ---- novelty memory ----------------------------------------------------------
  var seen = lsGet(LS.seen, {});             // handle -> {n, t}
  function decayed(h) {
    var e = seen[h]; if (!e) return 0;
    return e.n * Math.pow(0.5, (Date.now() - e.t) / (48 * 3600 * 1000));
  }
  function markShown(handles) {
    handles.forEach(function (h) { var d = decayed(h); seen[h] = { n: d + 0.34, t: Date.now() }; });
    var keys = Object.keys(seen);
    if (keys.length > 300) { keys.sort(function (a, b) { return seen[a].t - seen[b].t; }).slice(0, keys.length - 300).forEach(function (k) { delete seen[k]; }); }
    lsSet(LS.seen, seen);
  }

  // ---- light affinity profile ---------------------------------------------------
  var aff = lsGet(LS.aff, {});               // tag -> weight
  function learn(tags, w) {
    (tags || []).forEach(function (t) { t = String(t).toLowerCase(); aff[t] = (aff[t] || 0) * 0.98 + w; });
    var ks = Object.keys(aff);
    if (ks.length > 60) { ks.sort(function (a, b) { return aff[a] - aff[b]; }).slice(0, ks.length - 60).forEach(function (k) { delete aff[k]; }); }
    lsSet(LS.aff, aff);
  }
  function affinity(item) {
    var ts = item.tags || [], s = 0, mx = 0, k;
    for (k in aff) { if (aff[k] > mx) mx = aff[k]; }
    if (!mx) return 0.5;                     // cold start -> neutral
    for (var i = 0; i < ts.length; i++) { var w = aff[String(ts[i]).toLowerCase()]; if (w) s += w; }
    return Math.max(0, Math.min(1, s / (mx * 3)));
  }

  // ---- scoring ------------------------------------------------------------------
  function pick(pool, n, seed, merchOf, exclude) {
    var r = rng(seed);
    var scored = pool.filter(function (it) { return !exclude[it.h]; }).map(function (it) {
      var novelty = 1 / (1 + decayed(it.h));
      return { it: it, s: 0.42 * affinity(it) + 0.28 * novelty + 0.18 * merchOf(it) + 0.12 * r() };
    });
    scored.sort(function (a, b) { return b.s - a.s; });
    return scored.slice(0, n).map(function (x) { return x.it; });
  }

  // ---- renderers (reuse existing classes; server fallback markup is replaced) ----
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function imgTag(it, cls) { return it.img ? '<img src="' + esc(it.img) + '" width="42" height="42" alt="' + esc(it.t) + '" loading="lazy">' : '<span class="' + cls + '"></span>'; }

  function renderTrend(items) {
    var box = document.querySelector('.gtrend'); if (!box || !items.length) return;
    box.innerHTML = items.map(function (it, i) {
      return '<a href="' + esc(it.u) + '" class="gtrend__item" data-pulse-item data-h="' + esc(it.h) + '">' +
        '<span class="gtrend__rank">' + (i + 1) + '</span>' + imgTag(it, 'gtrend__ph') +
        '<span class="gtrend__info"><span class="gtrend__t">' + esc(it.t) + '</span><span class="gtrend__p">' + esc(it.p) + '</span></span></a>';
    }).join('');
  }
  function renderDrop(items) {
    var box = document.querySelector('.fdrop'); if (!box || !items.length) return;
    box.innerHTML = items.map(function (it) {
      return '<a href="' + esc(it.u) + '" class="fdrop__item" data-pulse-item data-h="' + esc(it.h) + '">' + imgTag(it, 'fdrop__ph') +
        '<span class="fdrop__info"><span class="fdrop__t">' + esc(it.t) + '</span><span class="fdrop__prices"><b class="fdrop__p">' + esc(it.p) + '</b><s class="fdrop__old">' + esc(it.cp) + '</s></span></span>' +
        '<span class="fdrop__disc">-' + (it.d || 0) + '%</span></a>';
    }).join('');
  }
  function renderPick(it) {
    var card = document.querySelector('.aipick'); if (!card || !it) return;
    var img = card.querySelector('.aipick__img'), name = card.querySelector('.aipick__name'), row = card.querySelector('.aipick__row');
    if (img) { var big = it.big || it.img; img.outerHTML = '<a class="aipick__img" href="' + esc(it.u) + '" data-pulse-item data-h="' + esc(it.h) + '">' + (big ? '<img src="' + esc(big) + '" alt="' + esc(it.t) + '" width="500" height="375">' : '<span class="fph"><span class="fph__mesh tint-cyan"></span></span>') + '</a>'; }
    if (name) name.textContent = it.t;
    if (row) row.innerHTML = '<span class="aipick__price neon-text">' + esc(it.p) + '</span><a class="fbtn fbtn-glass fbtn-sm" href="' + esc(it.u) + '">Add</a>';
  }

  // ---- countdown to end of current slot ------------------------------------------
  function armCountdown(onZero) {
    var cd = document.querySelector('[data-countdown]'); if (!cd) return;
    var h = cd.querySelector('[data-h]'), m = cd.querySelector('[data-m]'), s = cd.querySelector('[data-s]');
    function tick() {
      var left = SLOT_MS - (Date.now() % SLOT_MS);
      var t = Math.max(0, Math.floor(left / 1000));
      var p = function (x) { return String(x).padStart(2, '0'); };
      if (h) h.textContent = p(Math.floor(t / 3600)); if (m) m.textContent = p(Math.floor(t % 3600 / 60)); if (s) s.textContent = p(t % 60);
      if (t <= 1 && onZero) onZero();        // slot flipped -> re-roll the showcase live
    }
    tick(); setInterval(tick, 1000);
  }

  // ---- wiring ---------------------------------------------------------------------
  function readPool() {
    var el = document.querySelector('[data-pulse-pool]'); if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function run(off) {
    var pool = readPool(); if (!pool) return;
    var u = uid(), slot = slotNo(off), used = {};
    var trend = pick(pool.trend || [], 5, hash(u + ':' + slot + ':trend'), function (it) { return 1 - (it.i || 0) / 24; }, used);
    trend.forEach(function (it) { used[it.h] = 1; });
    var drop = pick(pool.drop || [], 4, hash(u + ':' + slot + ':drop'), function (it) { return Math.min(1, (it.d || 0) / 60); }, used);
    drop.forEach(function (it) { used[it.h] = 1; });
    var feat = pick((pool.feat || []).concat(pool.trend || []), 1, hash(u + ':' + slot + ':pick'), function () { return 0.5; }, used);
    renderTrend(trend); renderDrop(drop); renderPick(feat[0]);
    markShown(trend.concat(drop, feat).map(function (it) { return it.h; }));
  }

  function arm() {
    if (!readPool()) return;
    run(0);
    armCountdown(function () { setTimeout(function () { run(0); }, 1200); }); // new slot -> fresh drop, honest timer
    // affinity signals: click = strong, dwell-hover >600ms = weak
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-pulse-item]'); if (!a) return;
      var pool = readPool(), h = a.getAttribute('data-h');
      var it = pool && [].concat(pool.trend || [], pool.drop || [], pool.feat || []).find(function (x) { return x.h === h; });
      if (it) learn(it.tags, 3);
    }, true);
    var hoverT = null;
    document.addEventListener('mouseover', function (e) {
      var a = e.target.closest && e.target.closest('[data-pulse-item]');
      clearTimeout(hoverT); if (!a) return;
      hoverT = setTimeout(function () {
        var pool = readPool(), h = a.getAttribute('data-h');
        var it = pool && [].concat(pool.trend || [], pool.drop || [], pool.feat || []).find(function (x) { return x.h === h; });
        if (it) learn(it.tags, 0.5);
      }, 600);
    }, true);
    window.VIBE_PULSE = { reroll: function () { run(1); }, run: run };
  }

  if (document.readyState !== 'loading') arm(); else document.addEventListener('DOMContentLoaded', arm);
})();
